import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CapturumButtonModule } from '@capturum/ui/button';
import { CardComponent } from './card.component';

@NgModule({
  declarations: [
    CardComponent
  ],
  exports: [
    CardComponent
  ],
  imports: [
    CommonModule,
    CapturumButtonModule
  ]
})
export class CapturumCardModule { }
